import firebase from 'firebase/app';

import 'firebase/database';
import 'firebase/auth';


const prodConfig = {
  apiKey: "AIzaSyBV95WnfZMD3IHGYpwAahHojdbPSvtbUtg",
  authDomain: "https://sriuniversalsurakshacard.com",
  databaseURL: "https://sri-universal-suraksha.firebaseio.com",
  projectId: "sri-universal-suraksha",
  storageBucket: "sri-universal-suraksha.appspot.com",
  messagingSenderId: "79991574228"
};

const devConfig = {
  apiKey: "AIzaSyBV95WnfZMD3IHGYpwAahHojdbPSvtbUtg",
  authDomain: "https://sriuniversalsurakshacard.com",
  databaseURL: "https://sri-universal-suraksha.firebaseio.com",
  projectId: "sri-universal-suraksha",
  storageBucket: "sri-universal-suraksha.appspot.com",
  messagingSenderId: "79991574228"
};

const config = process.env.NODE_ENV === 'production'
  ? prodConfig
  : devConfig;

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}


const db = firebase.database();
const auth = firebase.auth();
export {
  db,
  auth
};
